/*
 * Copyright © 2022 EPO: European Patent Office.
 * ALL RIGHTS RESERVED
 */

import { createAsyncThunk } from '@reduxjs/toolkit';

/**
 * A debounced analogue of the `createAsyncThunk` from `@reduxjs/toolkit`
 * @param typePrefix - a string action type value
 * @param payloadCreator - a callback function that should return a promise containing the result
 *   of some asynchronous logic
 * @param wait - the number of milliseconds to delay.
 */
const createDebouncedAsyncThunk = (typePrefix, payloadCreator, wait) => {
  let timer = 0;
  let resolve;
  const invoke = () => {
    if (resolve) {
      resolve(true);
      resolve = undefined;
    }
  };
  const cancel = () => {
    if (resolve) {
      resolve(false);
      resolve = undefined;
    }
  };
  return createAsyncThunk(typePrefix, payloadCreator, {
    condition() {
      window.clearTimeout(timer);
      timer = window.setTimeout(() => {
        invoke();
        timer = 0;
      }, wait);
      cancel();
      return new Promise((res) => {
        resolve = res;
      });
    },
  });
};

export default createDebouncedAsyncThunk;
